import { useLearningUiTranslation } from '@features/learning/shared/use-learning-ui-translation'
import { Trash2, X } from 'lucide-react'
import type { FlashcardCard } from '@services/firebase/flashcards'
import { AppDrawer, AppEmptyState, LmsButton } from '@shared/ui'
import './flashcard-collection.css'

export function FlashcardSelectedDrawer({
  onClear,
  onClose,
  onRemoveCard,
  open,
  selectedCards,
}: {
  readonly onClear: () => void
  readonly onClose: () => void
  readonly onRemoveCard: (cardId: string) => void
  readonly open: boolean
  readonly selectedCards: FlashcardCard[]
}) {
  const ui = useLearningUiTranslation()
  return (
    <AppDrawer
      actions={
        <>
          <LmsButton
            disabled={selectedCards.length === 0}
            onClick={onClear}
            variant="outline"
          >
            {ui("Clear all")}</LmsButton>
          <LmsButton
            leadingIcon={<X aria-hidden="true" className="size-4" />}
            onClick={onClose}
            variant="primary"
          >
            {ui("Close")}</LmsButton>
        </>
      }
      description={ui("Selected cards will be reused by slideshow and gameplay.")}
      onClose={onClose}
      open={open}
      title={ui("My flashcard collection")}
    >
      {selectedCards.length === 0 ? (
        <AppEmptyState
          title={ui("No content available yet")}
          message={ui("No flashcards have been added to the collection yet.")}
        />
      ) : (
        <ul className="flashcardSelectedDrawerList">
          {selectedCards.map((card) => (
            <li
              className="flashcardSelectedDrawerItem"
              key={card.id}
            >
              <div className="flashcardSelectedDrawerCardCopy">
                <span className="flashcardSelectedDrawerCardTitle">
                  {card.title ?? card.id}
                </span>
                {card.categories?.length ? (
                  <span className="flashcardSelectedDrawerCardCategories">
                    {card.categories.join(', ')}
                  </span>
                ) : null}
              </div>
              <LmsButton
                leadingIcon={<Trash2 aria-hidden="true" className="size-4" />}
                onClick={() => {
                  onRemoveCard(card.id)
                }}
                size="sm"
                variant="outline"
              >
                {ui("Remove")}</LmsButton>
            </li>
          ))}
        </ul>
      )}
    </AppDrawer>
  )
}
